import TOAST from 'constants/toast';

export const createNewToast = (key = null, props) => ({
  id: Math.random(),
  isOpen: true,
  key,
  props: {
    direction: TOAST.DIRECTIONS.BOTTOM,
    onClick: () => {},
    ...props,
  },
});

export const findToastByKey = (toasts, keyToCompare) =>
  toasts.find(({ key }) => key === keyToCompare);

export const isToastsContentEqual = (firstToast, secondToast) =>
  firstToast.props.children !== secondToast.children;

export const deleteToastByKey = (toasts, keyToCompare) =>
  toasts.filter(({ key }) => key !== keyToCompare);
